import { App } from 'antd'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'
import { createSourceMap, updateSourceMap } from '../service/sourceMapService'
import sourceMapQueryKeys from './sourceMapQueryKeys'
import { SourceMap, SourceMapPayload } from '../types'

interface SaveSourceMapVariables {
  id?: number
  payload: SourceMapPayload
  // Skip the per-call success toast, e.g. when the caller batches several saves under one action
  // and shows a single aggregate toast itself.
  silent?: boolean
}

export const useSaveSourceMap = () => {
  const queryClient = useQueryClient()
  const { message } = App.useApp()
  const { t } = useTranslation()

  return useMutation({
    mutationFn: ({ id, payload }: SaveSourceMapVariables): Promise<SourceMap> =>
      id ? updateSourceMap(id, payload) : createSourceMap(payload),
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({ queryKey: sourceMapQueryKeys.all })
      if (!variables.silent) {
        message.success(t(variables.id ? 'messages:updateSuccess' : 'messages:createSuccess'))
      }
    },
    onError: () => {
      message.error(t('messages:saveError'))
    }
  })
}
